/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Sidebar_Nav_LabelInputs */

const en_directory_sidebar_nav_label = /** @type {(inputs: Directory_Sidebar_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigation`)
};

const zh_directory_sidebar_nav_label = /** @type {(inputs: Directory_Sidebar_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导航`)
};

/**
* | output |
* | --- |
* | "Navigation" |
*
* @param {Directory_Sidebar_Nav_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_sidebar_nav_label = /** @type {((inputs?: Directory_Sidebar_Nav_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Sidebar_Nav_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_sidebar_nav_label(inputs)
	return zh_directory_sidebar_nav_label(inputs)
});
export { directory_sidebar_nav_label as "directory.sidebar.nav_label" }